const m = require('minthril');
const { component } = require('../../component');

const Footer = component(() => ({
  view: () => m('footer.footer', [
    m('span', 'Spache'),
    m('a', { href: '/terms' }, 'Terms and Conditions'),
    m('a', { href: '/privacy' }, 'Privacy Policy'),
    m('a', { href: '/docs' }, 'Docs'),
    m('a', { href: '/contact' }, 'Contact')
  ])
}));

module.exports = { Footer };
